import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { scrollToId } from "./Reveal";

export default function MobileCTA() {
  const [show, setShow] = useState(false);
  const [nearDemo, setNearDemo] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    const demo = document.querySelector("#demo");
    let obs;
    if (demo) {
      obs = new IntersectionObserver(([e]) => setNearDemo(e.isIntersecting), { rootMargin: "-15% 0px" });
      obs.observe(demo);
    }
    return () => {
      window.removeEventListener("scroll", onScroll);
      obs?.disconnect();
    };
  }, []);

  return (
    <AnimatePresence>
      {show && !nearDemo && (
        <motion.div
          initial={{ y: 96, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 96, opacity: 0 }}
          transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
          className="fixed inset-x-4 bottom-4 z-50 lg:hidden"
          data-testid="mobile-sticky-cta"
        >
          <button
            onClick={scrollToId("#demo")}
            data-testid="mobile-sticky-cta-btn"
            className="flex w-full items-center justify-center gap-2 rounded-full bg-terra px-6 py-4 text-sm font-semibold text-paper shadow-[0_18px_45px_-12px_rgba(200,90,50,0.65)]"
          >
            Book a Demo <ArrowRight className="h-4 w-4" />
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
